export function PostalCodeRequired (country){
    if (country === ""){
      return true
    } else {
      var exemptCountries = ['AE', 'AF', 'AG', 'AI', 'AL', 'AN', 'AO', 'AW', 'BB', 'BF', 'BH', 'BI', 'BJ', 'BM', 'BO', 'BS', 'BT', 'BW', 'BZ', 'CD', 'CF', 'CG', 'CI', 'CK', 'CL', 'CM', 'CO', 'CR', 'CV', 'DJ', 'DM', 'DO', 'EC', 'EG', 'ER', 'ET', 'FJ', 'FK', 'GA', 'GD', 'GH', 'GI', 'GM', 'GN', 'GQ', 'GT', 'GW', 'GY', 'HK', 'HN', 'HT', 'IE', 'IQ', 'IR', 'JM', 'JO', 'KE', 'KH', 'KI', 'KM', 'KN', 'KP', 'KW', 'KY', 'LA', 'LB', 'LC', 'LK', 'LR', 'LS', 'LY', 'ML', 'MM', 'MO', 'MR', 'MS', 'MT', 'MU', 'MW', 'MZ', 'NA', 'NE', 'NG', 'NI', 'NP', 'NR', 'NU', 'OM', 'PA', 'PE', 'PF', 'PY', 'QA', 'RW', 'SA', 'SB', 'SC', 'SD', 'SL', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SY', 'TC', 'TD', 'TG', 'TL', 'TO', 'TT', 'TV', 'TZ', 'UG', 'UY', 'VC', 'VE', 'VG', 'VN', 'VU', 'WS', 'XA', 'XB', 'XC', 'XE', 'XL', 'XM', 'XN', 'XS', 'YE', 'ZM', 'ZW',]
      if (exemptCountries.includes(country)){
        return true
      } else {
        return false
      }
    }
  }

  export function returnFormattedAddressMapsAPI(response){
    const formattedAddress = {}
    response.address_components.forEach(component => {
      if (component.types.includes('country')){
        formattedAddress.country = component.short_name
      } else if (component.types.includes('postal_town') || component.types.includes('locality') ){
        formattedAddress.city = component.long_name
      } else if (component.types.includes('postal_code')){
        formattedAddress.postcode = component.long_name
      } else if (component.types.includes('street_number')){
        formattedAddress.address_line_one = component.long_name
      } else if (component.types.includes('route')){
        if (formattedAddress.address_line_one){
          formattedAddress.address_line_one += " " + component.long_name
        } else {
          formattedAddress.address_line_one = component.long_name

        }
      }
    })
    return formattedAddress
  }